// @flow

import { AccountUser } from './AccountUser'

// @deprecated; please use AccountUser
export const User = AccountUser
